import { SupervisorMenuComponent } from './../menu/supervisor-menu/supervisor-menu.component';
//import { ReceptionistMenuComponent } from './../menu/receptionist-menu/receptionist-menu.component';
import { EmployeePatientMenuComponent } from './../menu/employee-pateint-menu/employee-pateint-menu.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthHomeRoutingModule } from './auth-home-routing.module';
import { AuthHomeComponent } from './auth-home/auth-home.component';
import { SpinnerComponent } from '../dashboard/spinner/spinner.component';
import { StartSidebarComponent } from '../sidebar/start-sidebar/start-sidebar.component';
import { AdminMenuComponent } from '../menu/admin-menu/admin-menu.component';
import { TopToolbarComponent } from '../toolbar/top-toolbar/top-toolbar.component';
import { FooterComponent } from '../toolbar/footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule, MatDialogModule, MatIconModule, MatButtonModule, MatRadioModule, MatProgressSpinnerModule } from '@angular/material';
import { MaterialModule } from '../material-module';
import { SatPopoverModule } from '@ncstate/sat-popover';
import { SharedModule } from '../shared/models/shared.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { NotificationModule } from '../notification/notification.module';
import { ComponentsModule } from '../shared/components/components.module';
import { AppTransModule } from '../app-trans/app-trans.module';
import { PostsService } from '../dashboard/services/posts.service';
import { DashboardModule } from '../dashboard/dashboard.module';
import { ReceptionistMenuComponent } from '../menu/receptionist-menu/receptionist-menu.component';
import { ContentAdminMenuComponent } from '../menu/content-admin-menu/content-admin-menu.component';
import { ExaminerMenuComponent } from '../menu/examiner-menu/examiner-menu.component';
import { PatientMenuComponent } from '../menu/patient-menu/patient-menu.component';

import { SpecialistMenuComponent } from '../menu/specialist-menu/specialist-menu.component';

@NgModule({

  declarations: [SpinnerComponent  , AuthHomeComponent ,StartSidebarComponent 

    , AdminMenuComponent,
     TopToolbarComponent, FooterComponent , EmployeePatientMenuComponent , ExaminerMenuComponent ,PatientMenuComponent,
      ReceptionistMenuComponent,ContentAdminMenuComponent,SpecialistMenuComponent,SupervisorMenuComponent] ,
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    MatDialogModule,
    MaterialModule,
    MatIconModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatRadioModule,
    SatPopoverModule,
    SharedModule, ToolbarModule , MatProgressSpinnerModule,NotificationModule ,ComponentsModule ,
    AppTransModule,
    AuthHomeRoutingModule,
    DashboardModule,

  ] ,
  schemas: [
   
  ],
  providers : [
   PostsService

  ]
  
})
export class AuthHomeModule { }
